import React, { useContext, useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TextField,
  IconButton,
  colors,
  InputAdornment,
  Tooltip,
  Avatar,
} from "@mui/material";
import { Link } from "react-router-dom";

import Grid from "@mui/material/Grid2";

import "./login.scss";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import log from "../../Assets/login-pic.png";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
// Src
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import logo from "../../Assets/favicon.ico";
import CamFlag from "../../Assets/Cambodia.png";
import EngFlag from "../../Assets/United_Kingdom.png";
import { LOGIN } from "../../Schema/Users";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";

const Login = () => {
  // ===================== Change Language ==========================
  const { language, changeLanguage, setAlert, dispatch } =
    useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [iconReload, setIconReload] = useState(false);
  const navigate = useNavigate();

  // hide password hook
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [logIn] = useMutation(LOGIN, {
    onCompleted: ({ logIn }) => {
      // console.log("logIn:::", logIn);
      // if (logIn?.is_success === true) {
      if (logIn?.is_success) {
        setAlert(true, "success", logIn?.message);

        setTimeout(() => {
          localStorage.setItem("token", JSON.stringify(logIn?.data?.token));
          localStorage.setItem(
            "logIn",
            JSON.stringify(logIn?.data?.user)
          );
          dispatch({
            type: "LOGGED_IN_USER",
            payload: {
              token: logIn?.data?.token,
            },
          });
          navigate("/dashboard");
          setIconReload(false);
        }, 500);

      } else {
        setIconReload(false);
        setAlert(true, "error", logIn?.message);
     
      }
    },
    onError: (err) => {
      setIconReload(false);
      setAlert(true, "error", err?.message);
      console.log("first", err)
    },
  });

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email().required("Required"),
    password: Yup.string()
      .required("Required")
      .min(8, "Password must be 8 characters!"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      setIconReload(true);
      logIn({
        variables: {
          input: {
            ...values,
          },
        },
      });
    },
  });

  const { errors, touched, handleSubmit, getFieldProps } = formik;

  // ===========================  Resize width ==========================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <Stack
      direction="column"
      justifyContent="center"
      className="login-container-page"
    >
      <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Grid container className="box-container" sx={{ width: width < 450 ? "380px !important" : "800px" }}
            >
              {
                width < 450 ? (
                  <Grid size={{ xs: 12 }} sx={{ padding: "40px 10px 30px 20px" }}>
                    <Stack direction="column" spacing={3}>
                      <Stack direction={`row`} justifyContent={`center`}>
                        <Stack
                          direction="column"
                          spacing={1}
                          justifyContent={`center`}
                          alignItems={`center`}
                        >
                          <img src={logo} alt="logo" className="img" />
                          <Typography className={language === "en" ? "login-subtitle" : "login-subtitle-kh"}>
                            {t("system-name")}
                          </Typography>
                        </Stack>
                      </Stack>

                      <Stack
                        direction="column"
                        justifyContent="center"
                        width="100%"
                        className="box-login"
                        spacing={2}
                      >
                        <Stack direction="column">
                          <Typography
                            className={
                              language === "en" ? "label-login" : "label-login-kh"
                            }
                          >
                            {t("email")}
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            className="input-login"
                            placeholder="example@company.com"
                            {...getFieldProps("email")}
                            error={Boolean(touched.email && errors.email)}
                            helperText={touched.email && errors.email}
                          />
                        </Stack>
                        <Stack>
                          <Typography
                            className={
                              language === "en" ? "label-login" : "label-login-kh"
                            }
                          >
                            {t("password")}
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder={t("password")}
                            type={show ? "text" : "password"}
                            {...getFieldProps("password")}
                            error={Boolean(touched.password && errors.password)}
                            helperText={touched.password && errors.password}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="start"
                                  onClick={handleClick}
                                >
                                  {show ? (
                                    <VisibilityIcon className="viewpw-icon" />
                                  ) : (
                                    <VisibilityOffIcon className="viewpw-icon" />
                                  )}
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <Link to="/forgotpassword">
                          <Typography
                            className={
                              language === "en" ? "forgot-pwd" : "forgot-pwd-kh"
                            }
                          >
                            {t("forgot_password")}
                          </Typography>
                        </Link>
                      </Stack>
                      <Stack direction="column" spacing={1}>
                        <Stack direction="column">
                          <Button
                            onClick={handleSubmit}
                            className={
                              language === "en" ? "btn-sign-in" : "btn-sign-in-kh"
                            }
                            type="submit"
                            endIcon={
                              iconReload ? (
                                <CircularProgress
                                  sx={{ color: "#fff" }}
                                  size="20px"
                                />
                              ) : null
                            }
                          >
                            {t("btn-sign-in")}
                          </Button>
                        </Stack>
                      </Stack>
                      <Typography className="footer-copy-right">
                        Copyright © {moment().format("YYYY")} Go Global IT. All
                        rights reserved.
                      </Typography>
                    </Stack>
                  </Grid>
                ) : (
                  <>
                    <Grid size={{ xs: 6 }} sx={{ padding: "40px 10px 30px 20px" }}>
                      <Stack direction="column" spacing={3}>
                        <Stack direction={`row`} justifyContent={`center`}>
                          <Stack
                            direction="column"
                            spacing={1}
                            justifyContent={`center`}
                            alignItems={`center`}
                          >
                            <img src={logo} alt="logo" className="img" />
                            <Typography className="login-subtitle">
                              {t("system-name")}
                            </Typography>
                          </Stack>
                        </Stack>

                        <Stack
                          direction="column"
                          justifyContent="center"
                          width="100%"
                          className="box-login"
                          spacing={2}
                        >
                          <Stack direction="column">
                            <Typography
                              className={
                                language === "en" ? "label-login" : "label-login-kh"
                              }
                            >
                              {t("email")}
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              className="input-login"
                              placeholder="example@company.com"
                              {...getFieldProps("email")}
                              error={Boolean(touched.email && errors.email)}
                              helperText={touched.email && errors.email}
                            />
                          </Stack>
                          <Stack>
                            <Typography
                              className={
                                language === "en" ? "label-login" : "label-login-kh"
                              }
                            >
                              {t("password")}
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              placeholder={t("password")}
                              type={show ? "text" : "password"}
                              {...getFieldProps("password")}
                              error={Boolean(touched.password && errors.password)}
                              helperText={touched.password && errors.password}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment
                                    position="start"
                                    onClick={handleClick}
                                  >
                                    {show ? (
                                      <VisibilityIcon className="viewpw-icon" />
                                    ) : (
                                      <VisibilityOffIcon className="viewpw-icon" />
                                    )}
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                          <Link to="/forgotpassword">
                            <Typography
                              className={
                                language === "en" ? "forgot-pwd" : "forgot-pwd-kh"
                              }
                            >
                              {t("forgot_password")}
                            </Typography>
                          </Link>
                        </Stack>
                        <Stack direction="column" spacing={1}>
                          <Stack direction="column">
                            <Button
                              onClick={handleSubmit}
                              className={
                                language === "en" ? "btn-sign-in" : "btn-sign-in-kh"
                              }
                              type="submit"
                              endIcon={
                                iconReload ? (
                                  <CircularProgress
                                    sx={{ color: "#fff" }}
                                    size="20px"
                                  />
                                ) : null
                              }
                            >
                              {t("btn-sign-in")}
                            </Button>
                          </Stack>
                        </Stack>
                        <Typography className="footer-copy-right">
                          Copyright © {moment().format("YYYY")} Go Global IT. All
                          rights reserved.
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid size={{ xs: 6 }} alignSelf="center">
                      <Stack direction="row" justifyContent="center" width="100%">
                        <img width="100%" src={log} alt="log" />
                      </Stack>
                    </Grid>
                  </>
                )
              }
            </Grid>
          </Form>
        </FormikProvider>
      </Stack>
      <Stack
        sx={{
          right: "20px",
          top: "10px",
          position: "absolute",
        }}
      >
        <Stack direction="column" justifyContent="center">
          {language === "en" ? (
            <Tooltip title="Change to Khmer" placement="left">
              <IconButton onClick={() => changeLanguage("kh")}>
                <Avatar src={EngFlag} sx={{ width: "25px", height: "25px" }} />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Change to English" placement="left">
              <IconButton onClick={() => changeLanguage("en")}>
                <Avatar src={CamFlag} sx={{ width: "25px", height: "25px" }} />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Login;
